module.exports = __webpack_public_path__ + "media/echope_pedido_drive.536a1a73.mp3";